import CurlSignatureFactory from './CurlSignatureFactory';
import NodejsSignatureFactory from './NodejsSignatureFactory';
import ObjcSignatureFactory from './ObjcSignatureFactory';
import SwiftSignatureFactory from './SwiftSignatureFactory';
import JavaSignatureFactory from './JavaSignatureFactory';
import KotlinSignatureFactory from './KotlnSignatureFactory';
import DartSignatureFactory from '@/components/docs-main/reference-pages/signature/signature-factory/DartSignatureFactory';
import CsharpSignatureFactory from '@/components/docs-main/reference-pages/signature/signature-factory/CsharpSignatureFactory';
import GrpcSignatureFactory from '@/components/docs-main/reference-pages/signature/signature-factory/GrpcSignatureFactory';

export default function SignatureFactory(lang: string, kind: string) {
  switch (lang) {
    case 'curl':
      return CurlSignatureFactory(kind);
    case 'grpc':
      return GrpcSignatureFactory(kind);
    case 'nodejs':
      return NodejsSignatureFactory(kind);
    case 'javascript':
      return NodejsSignatureFactory(kind);
    case 'objc':
      return ObjcSignatureFactory(kind);
    case 'swift':
      return SwiftSignatureFactory(kind);
    case 'java':
      return JavaSignatureFactory(kind);
    case 'kotlin':
      return KotlinSignatureFactory(kind);
    case 'dart':
      return DartSignatureFactory(kind);
    case 'csharp':
      return CsharpSignatureFactory(kind);
    default:
      return {
        getSignature(_method: any): null {
          return null;
        },
      };
  }
}
